import React, { useMemo } from 'react';

import ROLE_INTELLIGENCE_KPI_MOCK_DATA from '../../../../mock-data/roleIntelligenceKpiMockData';
import type { RoleIntelligenceRow } from '../../../../mock-data/roleIntelligenceRolesTableMockData';
import { KPICards } from '../../../Shared/KPICards';
import type { KPICardData } from '../../../Shared/KPICards/type';
import { KPI_LAYOUTS } from '../../../Shared/KPICards/type';

import RoleIntelligenceControls from './RoleIntelligenceControls';
import RoleIntelligenceTable from './RoleIntelligenceTable';

import './RoleIntelligenceKPIs.css';

interface RoleIntelligenceKPIsProps {
  onRoleRowClick?: (role: RoleIntelligenceRow) => void;
}

/**
 * Renders the Role Intelligence KPIs section including KPI cards,
 * risky roles, filter controls, and a roles data table.
 * @param {RoleIntelligenceKPIsProps} props - Component props
 * @param {(role: RoleIntelligenceRow) => void} [props.onRoleRowClick] - Callback fired when a table row is clicked
 * @returns {React.ReactElement} The Role Intelligence KPIs layout
 */
function RoleIntelligenceKPIs({
  onRoleRowClick = undefined,
}: RoleIntelligenceKPIsProps): React.ReactElement {
  const kpiCards: KPICardData[] = useMemo(
    () => ROLE_INTELLIGENCE_KPI_MOCK_DATA,
    []
  );

  return (
    <div className='LicenseManagement-RoleIntelligenceKPIs'>
      <KPICards cards={kpiCards} layout={KPI_LAYOUTS.VERTICAL} />
      <RoleIntelligenceControls />
      <RoleIntelligenceTable onRowClick={onRoleRowClick} />
    </div>
  );
}

RoleIntelligenceKPIs.defaultProps = {
  onRoleRowClick: undefined,
};

export default RoleIntelligenceKPIs;
